import React, { createContext, useState, useContext, useEffect } from "react";

const ZoneContext = createContext();

const LOCAL_STORAGE_KEY = "app_selected_zone";

const zoneOptions = [
    { value: "1", label: "Europa" },
    { value: "2", label: "México" },
    { value: "3", label: "Países no GOA" },
];

export const ZoneProvider = ({ children }) => {
    const [selectedZone, setSelectedZone] = useState(() => {
        try {
            const item = window.localStorage.getItem(LOCAL_STORAGE_KEY);
            return item ? JSON.parse(item) : zoneOptions[1];
        } catch (error) {
            console.error("Error al leer de localStorage", error);
            return zoneOptions[1];
        }
    });

    useEffect(() => {
        try {
            window.localStorage.setItem(
                LOCAL_STORAGE_KEY,
                JSON.stringify(selectedZone)
            );
        } catch (error) {
            console.error("Error al guardar en localStorage", error);
        }
    }, [selectedZone]);

    const value = {
        selectedZone,
        setSelectedZone,
        zoneOptions,
    };

    return (
        <ZoneContext.Provider value={value}>{children}</ZoneContext.Provider>
    );
};

export const useZone = () => {
    const context = useContext(ZoneContext);
    if (context === undefined) {
        throw new Error("useZone must be used within a ZoneProvider");
    }
    return context;
};
